var map = {
	"./community-category/index.sync.tsx": 1169,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 1179,
	"./header-navigation/index.sync.tsx": 1222,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 1251,
	"./knowledge-base/index.sync.tsx": 1263,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 1280,
	"./widget-featured-topics/index.sync.tsx": 679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1819;